<template>
    <v-row id="stats" justify="center" align="start" class="mx-0 px-0 portrait-stats">
        <v-col cols="12" class="mx-0 px-0 py-0 my-0">
            <v-row class="mx-0 px-1 py-0 my-0" justify="center" align="start">
                <v-col v-for="team in teams" :key="`actions-${team.side}`" cols="6" class="px-1 pt-3 pb-1">
                    <div class="p-actions">
                        <v-btn
                            v-for="action in quickActions"
                            :key="action.label"
                            class="p-actions__btn"
                            depressed
                            :dark="!team.light"
                            :light="team.light"
                            :color="team.color"
                            @click="$emit('quick-action', action.category, team.side)"
                        >
                            <v-icon small left>{{ action.icon }}</v-icon>{{ action.label }}
                        </v-btn>
                    </div>
                </v-col>
                <v-col v-for="team in teams" :key="`court-${team.side}`" cols="6" class="mx-0 px-1 my-0 py-0">
                    <div class="p-court-title">On court</div>
                    <div
                        v-for="item in team.court"
                        :key="item.player.id"
                        class="p-player"
                        @click="$emit('player-click', item.player, team.side)"
                    >
                        <div class="p-player__jersey" :style="{ backgroundColor: team.color, color: team.textColor }">
                            {{ item.jersey }}
                            <v-icon v-if="item.mvp" x-small :color="team.textColor" class="p-player__mvp">mdi-crown</v-icon>
                        </div>
                        <div class="p-player__photo">
                            <v-icon color="grey"> mdi-account </v-icon>
                        </div>
                        <div class="p-player__stats">
                            <div class="p-player__points">{{ item.points }}<small>pts</small></div>
                            <div class="p-player__line">
                                {{ item.rebounds }}r · {{ item.assists }}a
                                <span class="p-player__fouls" :class="item.foulClass">{{ item.fouls }}f</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="!team.court.length" class="p-court-empty">
                        No players on court
                    </div>
                </v-col>
                <v-col cols="12" class="mx-0 px-1 pt-3 pb-2 my-0">
                    <div class="p-bench-toggles">
                        <stats-bench-toggle
                            v-for="team in teams"
                            :key="`bench-toggle-${team.side}`"
                            :team="team"
                            :open="openBenchSide === team.side"
                            @toggle="$emit('toggle-bench', team.side)"
                        />
                    </div>
                    <v-expand-transition>
                        <stats-bench-panel
                            v-if="openTeam"
                            :team="openTeam"
                            @close="$emit('toggle-bench', openTeam.side)"
                            @player-click="$emit('player-click', $event, openTeam.side)"
                        />
                    </v-expand-transition>
                </v-col>
                <v-col cols="12" class="px-2">
                    <slot name="feed" />
                </v-col>
                <v-col cols="12" class="px-2 pt-2 pb-6">
                    <v-btn block large outlined color="red darken-1" class="p-end-match" @click="$emit('end-match')">
                        <v-icon left>mdi-flag-checkered</v-icon>End match
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
    import StatsBenchToggle from '@/components/stats/StatsBenchToggle'
    import StatsBenchPanel from '@/components/stats/StatsBenchPanel'

    // Phone layout of the live stats page. Purely presentational: the page passes the team views
    // (see Stats.vue teamViews) and handles the emitted actions.
    export default {
        name: 'StatsPortrait',
        components: { StatsBenchToggle, StatsBenchPanel },
        props: {
            teams: {
                type: Array,
                required: true
            },
            openBenchSide: {
                type: Number,
                default: null
            }
        },
        data: () => ({
            // one set per team
            quickActions: [
                { label: 'Sub', category: 'sub', icon: 'mdi-swap-horizontal' },
                { label: 'Turnover', category: 'to', icon: 'mdi-alert-circle-outline' },
                { label: 'Def. reb', category: 'dreb', icon: 'mdi-shield-outline' },
                { label: 'Off. reb', category: 'oreb', icon: 'mdi-arrow-up-bold-outline' }
            ]
        }),
        computed: {
            openTeam() {
                return this.teams.find(team => team.side === this.openBenchSide) || null
            }
        }
    }
</script>
